import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
var roundFilled = ___EmotionJSX("path", {
  d: "M3.37969 11.5158C3.22278 11.5539 3.09217 11.6718 3.02867 11.8323C3.01053 11.8795 3.00781 11.9022 3.00781 12.0001C3.00781 12.0981 3.01053 12.1207 3.02867 12.1679C3.09307 12.3303 3.22369 12.4473 3.38423 12.4854C3.43593 12.4972 4.40464 12.499 12.0001 12.499C19.5956 12.499 20.5643 12.4972 20.616 12.4854C20.7765 12.4473 20.9071 12.3303 20.9715 12.1679C20.9897 12.1207 20.9924 12.0981 20.9924 12.0001C20.9924 11.9022 20.9897 11.8795 20.9715 11.8323C20.9071 11.67 20.7765 11.5529 20.616 11.5149C20.5643 11.5031 19.5965 11.5012 11.9956 11.5022C4.63865 11.5031 3.42595 11.5049 3.37969 11.5158Z"
});
var roundLined = ___EmotionJSX("path", {
  d: "M3.37969 11.5158C3.22278 11.5539 3.09217 11.6718 3.02867 11.8323C3.01053 11.8795 3.00781 11.9022 3.00781 12.0001C3.00781 12.0981 3.01053 12.1207 3.02867 12.1679C3.09307 12.3303 3.22369 12.4473 3.38423 12.4854C3.43593 12.4972 4.40464 12.499 12.0001 12.499C19.5956 12.499 20.5643 12.4972 20.616 12.4854C20.7765 12.4473 20.9071 12.3303 20.9715 12.1679C20.9897 12.1207 20.9924 12.0981 20.9924 12.0001C20.9924 11.9022 20.9897 11.8795 20.9715 11.8323C20.9071 11.67 20.7765 11.5529 20.616 11.5149C20.5643 11.5031 19.5965 11.5012 11.9956 11.5022C4.63865 11.5031 3.42595 11.5049 3.37969 11.5158Z"
});
var sharpFilled = ___EmotionJSX("path", {
  d: "M3.0022 12.4992H20.9977V11.5015H3.0022V12.4992Z"
});
var sharpLined = ___EmotionJSX("path", {
  d: "M3.0022 12.4992H20.9977V11.5015H3.0022V12.4992Z"
});
var IconMinus = makeIcon('IconMinus', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconMinus;